import React, { useContext } from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

import { AccordionsContext, AccordionsGroupContext } from './AccordionsContext';

export type AccordionsItemSectionProps = {
  children: React.ReactNode;
  className?: string;
  /**
   * Keeps the section in the tree while it is shut, hidden by the `collapsed` class rather than
   * unmounted. Reach for it when the content owns state that has to survive being closed.
   *
   * `Accordions animated` implies it, for the same reason stated the other way round: there is
   * nothing to ease open if the content is not in the tree.
   *
   * The class carries `display: none`, so a collapsed section is still out of reach of
   * find-in-page and of the tab order. Override `.accordion-section.collapsed` to hide it some
   * other way - `animated` does exactly that, and reaches the same end with `visibility`.
   */
  keepMounted?: boolean;
  name?: string;
};

export const AccordionsItemSection = ({
  children,
  className,
  keepMounted = false,
  name,
}: AccordionsItemSectionProps) => {
  const { isExpanded } = useContext(AccordionsContext);
  const { animated } = useContext(AccordionsGroupContext);

  if (!isExpanded && !keepMounted && !animated) {
    return null;
  }

  return (
    <div
      className={AttrsHelper.formatClassname(
        'accordion-section',
        !isExpanded && 'collapsed',
        className
      )}
      data-test={name}
    >
      {children}
    </div>
  );
};
